import {
    CREATE_MASTER,
    FETCH_MASTER,
    FETCH_MASTERS,
    LIST_MASTERS,
    MODIFIED_MASTER,
    SHOW_MASTER
} from "./types";

const init = {
    isLoading: true,
    filter: {},
    list: [],
    active: {
        master: {},
        isLoading: true
    },
    page: 1,
    totals: 0,
    size: 10
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MASTERS:
            return {
                ...state,
                isLoading: true,
                filter: payload
            };
        case LIST_MASTERS:
            return {
                ...state,
                ...payload,
                isLoading: false
            };
        case FETCH_MASTER:
            return {
                ...state,
                active: {
                    isLoading: true,
                    master: {}
                }
            };
        case SHOW_MASTER:
            return {
                ...state,
                active: {
                    isLoading: false,
                    master: payload
                }
            };
        case CREATE_MASTER:
        case MODIFIED_MASTER:
            return {
                ...state,
                isLoading: true
            };
        default:
            return state;
    }
}